export default function copyToClipboard(text: string) {
    // Copy the text inside the text field
    return navigator.clipboard.writeText(text);
}
